import { BusinessUnit, ReportType, Series } from '@cambridgeassessment/lib-ee-commons';
import React from 'react';
import { useDispatch } from 'react-redux';
import thunks from '../../../store/series/thunks';
import { Report } from '../../../types/Series';
import ReportFC from './ReportFC';

interface Props {
  type: ReportType;
  report: Report;
  index: number;
  businessUnitId: BusinessUnit['id'];
  series: {
    id: Series['id'];
    name: Series['name'];
  };
  isBeingGenerated: boolean;
  reportLinkText?: string;
}

const ReportFCMain: React.FC<Props> = (props) => {
  const dispatch = useDispatch();

  const onReportLinkClick = (
    businessUnitId: BusinessUnit['id'],
    series: { id: Series['id']; name: Series['name'] },
    type: ReportType,
    index: number,
  ): void => {
    dispatch(thunks.downloadReportAction(businessUnitId, series, type, index));
  };

  return <ReportFC {...props} onClick={onReportLinkClick} />;
};

export default ReportFCMain;
